import * as types from '../constants/actionTypes';

// sagas
export const fetchProfileOptions = () => ({ type: types.FETCH_PROFILE_OPTIONS });
export const createProfile = () => ({ type: types.CREATE_PROFILE });

// messages
export const fetchProfileOptionsLoading = () => ({ type: types.FETCH_PROFILE_OPTIONS_LOADING });
export const fetchProfileOptionsError = () => ({ type: types.FETCH_PROFILE_OPTIONS_ERROR });
export const fetchProfileOptionsSuccess = () => ({ type: types.FETCH_PROFILE_OPTIONS_SUCCESS });

export const createProfileLoading = () => ({ type: types.CREATE_PROFILE_LOADING });
export const createProfileError = () => ({ type: types.CREATE_PROFILE_ERROR });
export const createProfileSuccess = data => ({
  type: types.CREATE_PROFILE_SUCCESS,
  data,
});
